import successIcon from "../assets/icons/successCircle.svg";
import pendingIcon from "../assets/icons/pendingCircle.svg";
import rejectedIcon from "../assets/icons/rejectedCircle.svg";
import uiText from "../../src/locales/langs/en/common.json";

export const NUMBER_OF_APPLICANT = [
  {
    name: "1",
    value: 1,
  },
  {
    name: "2",
    value: 2,
  },
  {
    name: "3",
    value: 3,
  },
  {
    name: "4",
    value: 4,
  },
];

export const APPLICANT_NUMBER_WORD = ["Primary", "nd", "rd", "th"];

export const NAME_TYPE = [
  {
    name: "W/o",
    value: 1,
  },
  {
    name: "H/o",
    value: 2,
  },
  {
    name: "S/o",
    value: 3,
  },
  {
    name: "D/o",
    value: 4,
  },
];

export const STATUS = [
  {
    name: "Yes",
    value: 1,
  },
  {
    name: "No",
    value: 0,
  },
];

export const applicantCountConstant = {
  numberKeys: {
    1: "Primary",
    2: "nd",
    3: "rd",
    4: "th",
  },
};

export const TRANSACTION_TYPE = [
  {
    name: "Single Transaction",
    value: "singleTransaction",
  },
  {
    name: "Multiple Transactions",
    value: "multipleTransactions",
  },
];

export const DYNAMIC_STEPS = [
  {
    label: "Step 1",
    description: `Primary Applicant Details`,
  },
  {
    label: "Step 2",
    description: `2<sup>nd</sup> Applicant Details`,
  },
  {
    label: "Step 3",
    description: `3<sup>rd</sup> Applicant Details`,
  },
  {
    label: "Step 4",
    description: `4<sup>th</sup> Applicant Details`,
  },
];

export const INITIAL_STEPS = [
  {
    label: "Step",
    description: `Review your Details`,
  },
  {
    label: "Step",
    description: `Payment Details`,
  },
  {
    label: "Step",
    description: `Terms & Conditions`,
  },
];

export const VOUCHER_DYNAMIC_STEPS = [
  {
    label: "Step 1",
    description: `Primary Applicant Details`,
  },
  {
    label: "Step 2",
    description: `2<sup>nd</sup> Applicant Details`,
  },
  {
    label: "Step 3",
    description: `3<sup>rd</sup> Applicant Details`,
  },
  {
    label: "Step 4",
    description: `4<sup>th</sup> Applicant Details`,
  },
];

export const VOUCHER_INITIAL_STEPS = [
  {
    label: "Step",
    description: `Unit Preference`,
  },
  {
    label: "Step",
    description: `Review your Details`,
  },
  {
    label: "Step",
    description: `Payment Options`,
  }
];

export const LEAN_FORM_DYNAMIC_STEPS = [
  {
    label: "Step 1",
    description: `Basic Details`,
  },
  {
    label: "Step 2",
    description: `Primary Applicant Details`,
  },
  {
    label: "Step 3",
    description: `2<sup>nd</sup> Applicant Details`,
  },
  {
    label: "Step 4",
    description: `3<sup>rd</sup> Applicant Details`,
  },
  {
    label: "Step 5",
    description: `4<sup>th</sup> Applicant Details`,
  },
];

export const LEAN_FORM_INITIAL_STEPS = [
  {
    label: "Step",
    description: `Typology Preference | T&C`,
  },
  {
    label: "Step",
    description: `Payment Details`,
  }
];

export const DATE_START_YEAR = 1900;
export const ERROR_MESSAGE = "Something went wrong, please try again.";
export const MAX_FILE_SIZE_MB = 10; // 10MB for images
export const GST_FILE_SIZE_MB = 2; // 2MB for PDFs
export const PDF_FILE_SIZE_MB = 2; // 2MB for PDFs
export const ALLOWED_FILE_FORMATS = ["image/png", "image/jpg", "image/jpeg"];
export const ALLOWED_PDF_FILE_FORMATS = ["image/png", "image/jpg", "image/jpeg", "application/pdf"];
export const ALLOWED_ONLY_PDF_FILE = ["application/pdf"];

export const IDENTITY = {
  WIFE_OF: "W/o",
  HUSBAND_OF: "H/o",
  SON_OF: "S/o",
  DAUGHTER_OF: "D/o"
}

export const OCCUPATION = {
  EMPLOYED_PRIVATE_SECTOR: "Employed - Private Sector",
  EMPLOYED_GOVERNMENT_SECTOR: "Employed - Government Sector",
  ARMED_FORCES: "Armed Forces",
  BUSINESS: "Business",
  RETIRED: "Retired",
  HOMEMAKER: "Homemaker",
  I_WOULD_RATHER_NOT_SAY: "I would rather not say",
};


export const PRIMARY_SOURCE = {
  PurvaPrivilege: "Purva Privilege",
  ProvidentPremiere: "Provident Premier",
  PurvaChampion: "Purva Champion",
  ChannelPartner: 'Channel Partner',
}

export const RESIDENT_STATUS = {
  Nri: "NRI",
  Oci: "PIO/OCI",
  Indian: "Indian"
}

export const PURPOSE_OF_PURCHASE = [
  {
    "name": "Upgrading to a Newer Home",
    "value": "Moving to a better place"
  },
  {
    "name": "Own a Self-Designed Home",
    "value": "Wanting to own a Self Designed Home"
  },
  {
    "name": "For Family (Parents/Spouse/Children)",
    "value": "Purchasing for Parents/Spouse/Children"
  },
  {
    "name": "Investment",
    "value": "Investment Purpose"
  },
  {
    "name": "Vacation or Weekend Home​",
    "value": "Weekend Home/Farm Home"
  },
  {
    "name": "Others",
    "value": "Others"
  }
];

export const DOC_MESSAGE = "Physical Copy to be submitted offline"

export const COMPARE_VALUE = {
  Spouse: "Spouse",
  Puravankara: "Puravankara",
  Provident: "Provident",
  PurvaLand: "Purva Land"
}

export const FORM_PHASE = {
  VOUCHER: "VOUCHER",
  EOI: "EOI"
}

export const MAX_TRANSACTION_LIMIT = 10;

export const BOOKING_FORM_STATUS = {
  NOT_SENT: 'Form not Sent',
  SENT: 'Form Sent',
  NEW: "New",
  PRE_BOOKING_SUBMITTED: 'Pre-booking Docs Added',
  IN_PROGRESS: 'Form filling in progress',
  NOT_SIGNED: 'Form Filled, not signed',
  PARTIALLY_SIGNED: 'Partially signed',
  FILLING_BY_RM: 'Form filling started by RM',
  SIGNED: 'Signed - Digitally',
  SIGNED_OFFLINE: 'Signed offline',
  RM_UPLOAD_DONE: 'Signed - RM Uploaded Offline Docs',
  OFFICE_USE_SUBMITTED: 'Signed - Office Use Updated',
}


export const UNIT_PREFERENCE_TOPOLOGY = [
  // {
  //   "value": "1 BHK",
  //   "name": "1 BHK"
  // },
  // {
  //   "value": "2 BHK",
  //   "name": "2 BHK"
  // },
  {
    "value": "3 BHK",
    "name": "3 BHK"
  },
  {
    "value": "4 BHK",
    "name": "4 BHK"
  },
  // {
  //   "value": "Plots",
  //   "name": "Plots"
  // },
  // {
  //   "value": "To be decided",
  //   "name": "I will decide later"
  // },
]

export const HOUSING_UNIT_TABLE_DATA = [
  {
    typology: "2 BHK Comfort",
    area: "-1006 Sq.Ft",
    value: "2BHK Normal",
  },
  {
    typology: "2 BHK Comfort",
    area: "-1106 Sq.Ft",
    value: "2BHK Comfort",
  },
  {
    typology: "3 BHK Comfort",
    area: "-1326 Sq.Ft",
    value: "3BHK Normal",
  },
];

export const PLOTS_UNIT_TABLE_DATA = [
  {
    typology: "Town House Plot",
    area: "Up to 1000 Sq.ft.",
    price: "60-70L",
    value: "Town House Plot",
  },
  {
    typology: "Villa Plot",
    area: "1001 Sq.ft.to 1350 Sq.ft.",
    price: "65-75L",
    value: "Villa Plot",
  },
  {
    typology: "Bungalow Plot",
    area: "1351 Sq.ft.to 1650 Sq.ft.",
    price: "70-80L",
    value: "Bungalow Plot",
  },
  {
    typology: "Mansion Plot",
    area: "1651 Sq.ft.to 2200 Sq.ft.",
    price: "75-85L",
    value: "Mansion Plot",
  },
  {
    typology: "Estate Plot",
    area: "Above 2200 Sq.ft.",
    price: "80-90L",
    value: "Estate Plot",
  },
  {
    typology: "Unit Facing Directions",
    directions:
      ["North", "South", "East", "West", "Northwest", "Southwest", "Northeast", "Southeast"],
    value: "facingDirection",
  },
]


export const TOWER_OPTIONS = [
  {
    "name": "Tower 1",
    "value": "T1",
  },
  {
    "name": "Tower 2",
    "value": "T2",
  },
  {
    "name": "Tower 3",
    "value": "T3",
  },
]

export const FLOOR_OPTIONS = [
  {
    "name": "Floor 1",
    "value": "1",
  },
  {
    "name": "Floor 2",
    "value": "2",
  },
  {
    "name": "Floor 3",
    "value": "3",
  },
  {
    "name": "Floor 4",
    "value": "4",
  },
  {
    "name": "Floor 5",
    "value": "5",
  },
  {
    "name": "Floor 6",
    "value": "6",
  },
  {
    "name": "Floor 7",
    "value": "7",
  },
  {
    "name": "Floor 8",
    "value": "8",
  },
  {
    "name": "Floor 9",
    "value": "9",
  },
  {
    "name": "Floor 10",
    "value": "10",
  },
]

export const SERIES_OPTIONS = [
  {
    "name": "Grand",
    "value": "Grand",
  },
  {
    "name": "Lux",
    "value": "Lux",
  },
]

export const UNIT_OPTIONS = [
  {
    "name": "Unit 1",
    "value": "Unit 1",
  },
  {
    "name": "Unit 2",
    "value": "Unit 2",
  },
  {
    "name": "Unit 3",
    "value": "Unit 3",
  },
  {
    "name": "Unit 4",
    "value": "Unit 4",
  },
  {
    "name": "Unit 5",
    "value": "Unit 5",
  },
  {
    "name": "Unit 6",
    "value": "Unit 6",
  },
]


export const formatIndianCurrencyShort = (value) => {
  if (!value || isNaN(value)) return "₹0";

  const absValue = Math?.abs(value);

  if (absValue >= 10000000) {
    // Crores
    const inCr = absValue / 10000000;
    return `${inCr?.toFixed(inCr % 1 === 0 ? 0 : 2)}Cr`;
  } else if (absValue >= 100000) {
    // Lakhs
    const inLakh = absValue / 100000;
    return `${inLakh?.toFixed(inLakh % 1 === 0 ? 0 : 1)}L`;
  } else if (absValue >= 1000) {
    // Thousands
    const inThousand = absValue / 1000;
    return `${inThousand?.toFixed(inThousand % 1 === 0 ? 0 : 1)}K`;
  }

  // Less than ₹1,000
  return `${absValue?.toFixed(0)}`;
};

export const EOIPaymentMode = {
  OFFLINE: "Offline",
  GATEWAY: "Gateway",
}

export const EOIFinanceStatus = {
  UNVERIFIED: 'Pending Reco',
  VERIFIED: 'Realized',
  REJECTED: 'Rejected',
  REFUNDED: 'Refunded',
  REVERSED: 'Not Realized',
};

export const getStatusStyles = (status) => {
  switch (status) {
    case EOIFinanceStatus.VERIFIED:
      return {
        bg: "rgba(34, 197, 94, 0.08)",
        color: "#118D57",
        text: EOIFinanceStatus.VERIFIED,
        icon: successIcon,
      };

    case EOIFinanceStatus.REJECTED:
      return {
        bg: "#F0D7D2",
        color: "#B71D18",
        text: EOIFinanceStatus.REJECTED,
        icon: rejectedIcon,
      };
    case EOIFinanceStatus.REVERSED:
      return {
        bg: "#F0D7D2",
        color: "#B71D18",
        text: EOIFinanceStatus.REVERSED,
        icon: rejectedIcon,
      };

    case EOIFinanceStatus.REFUNDED:
      return {
        bg: "#F0D7D2",
        color: "#B71D18",
        text: EOIFinanceStatus.REFUNDED,
        icon: rejectedIcon,
      };
    default:
      return {
        bg: "rgba(255, 171, 0, 0.08)",
        color: "#B76E00",
        text: EOIFinanceStatus.UNVERIFIED,
        icon: pendingIcon,
      };
  }
};
export const EOIFormStatus = {
  CREATED: '1-Form Link Shared',
  IN_PROGRESS: '2-Form fill in progress',
  UNVERIFIED: '3-Form Submitted',
  MIS_VERIFIED: '4-MIS Verified',
  MIS_REQUESTED_CHANGES: '5-MIS-Resubmission requested',
  MIS_UPDATED: '6-Updated as per MIS',
  CRM_VERIFIED: '7-CRM Verified',
  CRM_REQUESTED_CHANGES: '8-CRM-Resubmission requested',
  CRM_UPDATED: '9-Updated as per CRM',
  ACTIVE: '10-Active',
  UPGRADING: '11-Upgrade in progress',
  UPGRADED: '12-Upgraded',
  CONVERTED: '13-Converted',
  CANCELLED_NOT_REALISED: '14-Cancelled – Not realised',
  CANCEL_REQUESTED: '15-Cancellation Requested by RM by RM',
  CANCEL_ACCEPTED: '16-Cancellation Request Accepted',
  CANCEL_APPROVED: '17-Cancellation – In Progress by CRM',
  REFUND_INITIATED: '18-Refund Initiated',
  CANCELLED: '19-Cancellation – Complete & Refunded',
};

export const FrontEndStatusValue = {
  '1-Form Link Shared': 'Pending Verification',
  '2-Form fill in progress': 'Pending Verification',
  '3-Form Submitted': 'Pending Verification',
  '4-MIS Verified': 'Pending Verification',
  '5-MIS-Resubmission requested': 'Pending Verification',
  '6-Updated as per MIS': 'Pending Verification',
  '7-CRM Verified': 'Pending Verification',
  '8-CRM-Resubmission requested': 'Pending Verification',
  '9-Updated as per CRM': 'Pending Verification',
  '10-Active': 'Active',
  '11-Upgrade in progress': 'Upgrade in progress',
  '12-Upgraded': 'Upgraded',
  '13-Converted': 'Converted',
  '14-Cancelled – Not realised': 'Cancelled', // Tooltip: cancelled due to non-realization of payment
  '15-Cancellation Requested by RM by RM': 'Cancellation Requested',
  '16-Cancellation Request Accepted': 'Cancellation Request Accepted',
  '17-Cancellation – In Progress by CRM': 'Cancellation Request Accepted',
  '18-Refund Initiated': 'Cancellation Request Accepted',
  '19-Cancellation – Complete & Refunded': 'Cancelled & refunded',
};


export const getFrontEndStatus = (key) =>
  key ? FrontEndStatusValue[key] ?? key : '';

export const EOIPaymentStatus = {
  PENDING: 'Pending',
  PARTIALLY_PAID: 'Partially Paid',
  PAID: 'Paid',
  REFUNDED: 'Refunded',
}


export const STATUS_COLORS = {
  // Form Status Colors
  FORM_STATUS: {
    [EOIFormStatus.CREATED]: 'warning',
    [EOIFormStatus.IN_PROGRESS]: 'warning',
    [EOIFormStatus.UNVERIFIED]: 'warning',
    [EOIFormStatus.MIS_VERIFIED]: 'warning',
    [EOIFormStatus.MIS_REQUESTED_CHANGES]: 'warning',
    [EOIFormStatus.MIS_UPDATED]: 'warning',
    [EOIFormStatus.CRM_VERIFIED]: 'warning',
    [EOIFormStatus.CRM_REQUESTED_CHANGES]: 'warning',
    [EOIFormStatus.CRM_UPDATED]: 'warning',
    [EOIFormStatus.CANCEL_REQUESTED]: 'warning',
    [EOIFormStatus.CANCEL_ACCEPTED]: 'warning',
    [EOIFormStatus.CANCEL_APPROVED]: 'info',
    [EOIFormStatus.REFUND_INITIATED]: 'success',
    [EOIFormStatus.CANCELLED]: 'error',
    [EOIFormStatus.UPGRADING]: 'info',
    [EOIFormStatus.UPGRADED]: 'success',
    [EOIFormStatus.ACTIVE]: 'success',
    [EOIFormStatus.CONVERTED]: 'primary',
  },
  // Payment Status Colors
  PAYMENT_STATUS: {
    [EOIPaymentStatus.PENDING]: 'warning',
    [EOIPaymentStatus.PARTIALLY_PAID]: 'info',
    [EOIPaymentStatus.PAID]: 'success',
    [EOIPaymentStatus.REFUNDED]: 'error',
  },

  // Finance Status Colors
  FINANCE_STATUS: {
    [EOIFinanceStatus.UNVERIFIED]: 'warning',
    [EOIFinanceStatus.VERIFIED]: 'success',
    [EOIFinanceStatus.REJECTED]: 'error',
    [EOIFinanceStatus.REFUNDED]: 'error',
    [EOIFinanceStatus.REVERSED]: 'error',
  }
}

// Utility function to get actual color values from MUI color names
export const getMUIColorStyles = (colorName) => {
  const colorMap = {
    'primary': {
      color: '#1976d2',
      backgroundColor: 'rgba(25, 118, 210, 0.08)'
    },
    'secondary': {
      color: '#dc004e',
      backgroundColor: 'rgba(220, 0, 78, 0.08)'
    },
    'success': {
      color: '#118D57',
      backgroundColor: 'rgba(34, 197, 94, 0.08)'
    },
    'error': {
      color: '#B71D18',
      backgroundColor: 'rgba(183, 29, 24, 0.08)'
    },
    'warning': {
      color: '#B76E00',
      backgroundColor: 'rgba(255, 171, 0, 0.08)'
    },
    'info': {
      color: 'rgba(0, 108, 156, 1)',
      backgroundColor: 'rgba(0, 184, 217, 0.08)'
    },
    'default': {
      color: '#6B7280',
      backgroundColor: 'rgba(107, 114, 128, 0.08)'
    }
  };

  return colorMap[colorName] || colorMap['default'];
};

// Utility function to get status color styles for form status
export const getFormStatusStyles = (status) => {
  const colorName = STATUS_COLORS.FORM_STATUS[status] || 'default';
  return getMUIColorStyles(colorName);
};

export const BOOKING_AS_OPTIONS = uiText.landingPage.bookingAsOptions

export const UPLOAD_FILE_TYPES = uiText.commonUpload.fileTypes

export const FILE_TYPES_PROPS = {
  PDF: "PDF",
  IMAGE: "IMAGE",
  PDF_IMAGE: "PDF_IMAGE",
};

export const UPLOAD_TYPE = {
  PDF_IMAGE: 'both',
  PDF: 'pdf',
  IMAGE: 'image'
}
export const RESIDENTIAL_STATUS_OPTIONS = uiText.residentialStatusOptions

export const getKycOptions = (t) => [
  { name: t("kycOptions.0.name"), value: t("kycOptions.0.value") },
  { name: t("kycOptions.1.name"), value: t("kycOptions.1.value") },
];


export const CORPORATE_FORM_STEPS = (
  signatoryCount,
  entity,
  t,
) => {
  // Clamp signatory count between 1 and 4
  const count = Math.max(1, Math.min(4, Number(signatoryCount) || 1));

  const baseSteps = [
    {
      label: "Step",
      description: t("stepper.entityDetails", {
        entity,
      }),
    },
    {
      label: "Step",
      description: t("stepper.entityDocuments", {
        entity,
      }),
    },
  ];

  const signatorySteps = Array.from({ length: count }, (_, i) => {
    const labelText = t("stepper.authorizedSignatory");

    let description = "";
    if (i === 0) description = labelText;
    else if (i === 1) description = `2<sup>nd</sup> ${labelText}`;
    else if (i === 2) description = `3<sup>rd</sup> ${labelText}`;
    else description = `${i + 1}<sup>th</sup> ${labelText}`;

    return { label: "Step", description };
  });


  const tailSteps = [
    { label: "Step", description: t("stepper.reviewDetails") },
    { label: "Step", description: t("stepper.paymentDetails") },
    { label: "Step", description: t("stepper.termsAndConditions") },
  ];

  return [...baseSteps, ...signatorySteps, ...tailSteps];
};

export const CorporatePaymentMode = {
  OFFLINE: "Offline",
  GATEWAY: "Gateway",
}

export const CorporateFinanceStatus = {
  UNVERIFIED: 'Pending Reco',
  VERIFIED: 'Realized',
  REJECTED: 'Rejected',
  REFUNDED: 'Refunded',
  REVERSED: 'Not Realized',
};


export const OFFLINE_PAYMENT_METHODS = {
  CHEQUE: "CHEQUE",
  ONLINETRANSFER: "ONLINE TRANSFER",
  UPI_CARD: 'UPI CARD',
  EDC_MACHINE: 'EDC MACHINE',
}

export const BOOKING_AS = {
  INDIVIDUAL: "Individual",
  CORPORATE: "Corporate",
  PARTNERSHIP_FIRM: "Partnership Firm",
};

export const PAYMENT_ENTITY_TYPE = {
  BOOKING: 'bookings',
  VOUCHER: 'voucher',
}

export const TOTAL_BOOKING_AMOUNT = {
  BOOKING: '500000'
}


export const ADDRESS_PROOF_OPTIONS = [
  { name: "Driving License", value: "Driving License" },
  { name: "Voter ID", value: "Voter ID" },
  { name: "Electricity Bill", value: "Electricity Bill" },
  { name: "Passport", value: "Passport" },
  { name: "Telephone Bill", value: "Telephone Bill" },
];

export const REQUIRED_DOCS_FIELDS = [
  { name: "Cost Sheet", label: "Cost Sheet" },
  { name: "Allotment Letter", label: "Allotment Letter" },
];

export const PRIMARYDOCUMENT_OPTIONS = {
  Pan: 'PAN',
  Aadhaar: "Aadhaar"
}

export const MOTHER_TONGUE_OPTIONS = [
  { "name": "Hindi", "value": "Hindi" },
  { "name": "English", "value": "English" },
  { "name": "Bengali", "value": "Bengali" },
  { "name": "Telugu", "value": "Telugu" },
  { "name": "Marathi", "value": "Marathi" },
  { "name": "Tamil", "value": "Tamil" },
  { "name": "Urdu", "value": "Urdu" },
  { "name": "Gujarati", "value": "Gujarati" },
  { "name": "Kannada", "value": "Kannada" },
  { "name": "Odia", "value": "Odia" },
  { "name": "Malayalam", "value": "Malayalam" },
  { "name": "Punjabi", "value": "Punjabi" },
  { "name": "Assamese", "value": "Assamese" },
  { "name": "Maithili", "value": "Maithili" },
  { "name": "Konkani", "value": "Konkani" },
  { "name": "Sindhi", "value": "Sindhi" },
  { "name": "Dogri", "value": "Dogri" },
  { "name": "Kashmiri", "value": "Kashmiri" },
  { "name": "Manipuri", "value": "Manipuri" },
  { "name": "Santhali", "value": "Santhali" },
  { "name": "Bodo", "value": "Bodo" },
  { "name": "Nepali", "value": "Nepali" }
]

export const MARITAL_STATUS = {
  SINGLE: "Single",
  MARRIED: "Married",
  OTHER: "Other",
}

export const PAYMENT_MODE = {
  OFFLINE: "Direct",
  GATEWAY: "Payment Gateway",
}

export const OCCUPATION_OPTIONS = [
  {
    "name": "Employed - Private Sector",
    "value": "Employed - Private Sector"
  },
  {
    "name": "Employed - Government Sector",
    "value": "Employed - Government Sector"
  },
  {
    "name": "Armed Forces",
    "value": "Armed Forces"
  },
  {
    "name": "Business",
    "value": "Business"
  },
  {
    "name": "Retired",
    "value": "Retired"
  },
  {
    "name": "Homemaker",
    "value": "Homemaker"
  }
]
// --- Branch constants ---
export const BRANCH = {
  INDIAN_ARMY: "Indian Army",
  INDIAN_NAVY: "Indian Navy",
  INDIAN_AIR_FORCE: "Indian Air Force",
};

// --- Branch option list ---
export const BRANCH_OPTIONS = [
  { name: "Indian Army", value: "Indian Army" },
  { name: "Indian Navy", value: "Indian Navy" },
  { name: "Indian Air Force", value: "Indian Air Force" },
];


export const OTHERS = "Others"
export const MinorAge = 18;
export const RESIDING_AS = {
  OWNER: "Owner",
  TENANT: "Tenant",
}
export const OWNER_TYPE = {
  PRIMARY: "primaryOwner",
  SECONDARY: "secondaryOwner",
}

export const GATEWAY = {
  RAZORPAY: 'Razorpay',
  EASEBUZZ: 'Easebuzz'
}

export const SOURCE = [
  { value: 'Digital Medium', name: 'Digital Medium' },
  { value: 'Authorised Channel Partner', name: 'Authorised Channel Partner' },
  { value: 'Existing Customer', name: 'Existing Customer' },
  { value: 'Referred by Family/Friend', name: 'Referred by Family/Friend' },
]
export const PAYMENT_OPTIONS = {
  LUMPSUM: 'Lumpsum',
  DISTINCT: 'Distinct'
};
export const CAMPAIGN_STAGE = {
  LAUNCH: 'Launch',
  PREFILL: 'Pre-fill Booking Form'
};

export const BOOKING_STATUS = {
  PENDING: 'Pending',
  PRE_FILLED: 'Pre Filled',
  SIGNED: 'Signed',
}

export const CAMPAIGN_LIST_STATUS_OPTIONS = {
  ACTIVE_VOUCHER: 'Active | Voucher',
  ACTIVE_EOI: 'Active | EOI',
  ACTIVE_VOUCHER_AND_EOI: 'Active | Voucher and EOI',
  INACTIVE_VOUCHER: 'Inactive | Voucher',
  INACTIVE_EOI: 'Inactive | EOI',
  INACTIVE_VOUCHER_AND_EOI: 'Inactive | Voucher and EOI',
  PROJECT_LAUNCHED: 'Project Launched',
  PROJECT_ON_HOLD: 'Project on Hold',
  CANCELLED_AND_REFUNDED: 'Cancelled & Refunded',
  ARCHIVED: 'Archived'
}
export const VoucherAmountType = {
  FIXED: 'Fixed',
  BHK_WISE: 'BHK Wise',
}

export const SHOW_PAYMENT_METHOD_OPTION = false;

export const DisplayUnitType = {
  UNIT_NUMBER: 'Unit Number',
  TOWER_AND_SBA_SQFT: 'Tower and SBA Sq.Ft',
}

export const APPROVAL_STATUS = {
  APPROVE: "approve",
  REJECT: "reject",
}